import { Component, Input, SimpleChanges } from '@angular/core';
import { publicMethods } from '../../globals';
import { DataSharingService } from '../../services/data-sharing.service';
import { MISortString } from '../../classes/types';

@Component({
    selector: 'aira-responses',
    templateUrl: './aira-responses.component.html',
    styleUrl: './aira-responses.component.css',
    standalone: false
})
export class AiraResponsesComponent {
  @Input() airaResponses: any[] = [];
  @Input() moduleSectionId: string = '';
  @Input() previewOnly: boolean = false;
  @Input() moduleId: number = null;
  @Input() sortBy: MISortString;

  sortedAiraResponses = [];
  defaultAiraResponse = [];

  constructor(
    public pubMethods: publicMethods,
    public dataStore: DataSharingService
  ) {}

  ngOnInit(): void {
    this.defaultAiraResponse = [...this.airaResponses];
    this.sortResponses();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes['sortBy']?.firstChange) {
      this.sortResponses();
    }
  }

  sortResponses() {
    if (this.sortBy === null) {
      this.sortedAiraResponses = this.defaultAiraResponse;
      return;
    }
    this.sortedAiraResponses = this.airaResponses.sort((objA, objB) => {
      if (this.sortBy === 'date') {
        //TODO: not currently used
        const sortKey = 'date_generated';
        const dateA = new Date(objA[sortKey]).getTime();
        const dateB = new Date(objB[sortKey]).getTime();

        return dateB - dateA;
      }
      return objB[this.sortBy] - objA[this.sortBy];
    });
  }

  shouldSpanTwoColumns(displayType: string, answer: any): string {
    const twoColDisplayTypes = ['card_list', 'labelled_pills'];
    const hasThreeOrMoreItems = answer?.length >= 3;

    const hasData = this.pubMethods.hasData(answer);

    const longContents =
      hasData &&
      twoColDisplayTypes.includes(displayType) &&
      hasThreeOrMoreItems;

    let hasTwoColLongPills = false;
    if (displayType === 'pills') {
      //char length 25 or more should be considered long
      hasTwoColLongPills = hasData && answer?.some(str => str.length >= 25);
    }

    if (longContents || hasTwoColLongPills) {
      return 'grid-col-2';
    }
  }

  shouldRenderInsightCard(insightsData: Record<string, any>): boolean {
    if (this.dataStore.hideEmptyInsights() === false) {
      return true;
    }

    return this.pubMethods.hasData(insightsData);
  }
}
